import React, { useState } from "react";
import Layout from "../components/layout";

function MGR() {
  const [showAlert, setShowAlert] = useState(false);

  const handleTryClick = (e) => {
    e.preventDefault();
    setShowAlert(true);
  };

  const handleContinue = () => {
    window.open("https://music-genre-recognition-1.onrender.com/", "_blank");
    setShowAlert(false);
  };

  return (
    <div className="flex-grow bg-slate-900 text-slate-200">
      <Layout className="py-10">
        <div className="text-center font-sans py-4 font-medium md:text-3xl text-2xl">Music Genre Recognition Web App</div>
        <div className="text-center font-mono font-medium md:text-xl text-teal-300">using a carefully designed machine learning model.</div>
        <div className="flex items-center justify-center py-10">
          <button onClick={handleTryClick} className="border-2 border-teal-300 p-2 mx-4 mb-1 font-mono text-teal-300 shadow-teal-300 shadow-md hover:shadow-sm hover:shadow-teal-300">Try it!</button>
          <a href="https://github.com/AnandKri/Music-Genre-Recognition" target="_blank" rel="noopener noreferrer" className="inline-block border-2 border-teal-300 p-2 mx-4 mb-1 font-mono text-teal-300 shadow-teal-300 shadow-md hover:shadow-sm hover:shadow-teal-300">Git repo</a>
        </div>

        {showAlert && (
          <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
            <div className="bg-gray-900 border border-teal-400 text-teal-200 p-6 rounded shadow-lg w-80">
              <p className="mb-4 text-sm">
                Spotify Web API endpoint for retrieving song features are closed for service. To view the complete working demo, please click on the Git repo.
              </p>
              <div className="flex justify-end space-x-3">
                <button onClick={() => setShowAlert(false)} className="px-3 py-1 border border-teal-400 text-teal-200 hover:bg-teal-400 hover:text-black">close</button>
                <button onClick={handleContinue} className="px-3 py-1 border border-teal-400 text-teal-900 bg-teal-300 hover:bg-teal-200">continue</button>
              </div>
            </div>
          </div>
        )}
        <div className="md:w-3/4 mx-auto flex-col">
        <div className="py-4 md:w-1/2 md:mr-auto">
          <div className="py-1 text-slate-400 font-sans font-medium md:text-xl text-lg">Brief Overview</div>
          <div className="py-1 text-slate-200 font-sans font-medium">The Music Genre Recognition (MGR) project is a web application which predicts the genre for a song selected by the user. The application allows users to search for a song, and once a particular song is selected, user is presented with the true and predicted genres of the song.</div>
        </div>
        <div className="py-4 md:w-1/2 md:ml-auto">
          <div className="py-1 text-slate-400 font-sans font-medium md:text-xl text-lg">Problem Addressed</div>
          <div className="py-1 text-slate-200 font-sans font-medium">Music artists and streaming services annotate the genre of the music manually. Most of the time, the artists decide the genre of the song which they had created. Through this project I've tried to explore that to what extent does the music itself decides the genre of a song.</div>
        </div>
        </div>
      </Layout>
    </div>
  );
}

export default MGR;
